// src/config/oktaConfig.js

import { OktaAuth } from '@okta/okta-auth-js';


// Your Okta configuration
const oktaConfig = {
  issuer: process.env.REACT_APP_OKTA_ISSUER,
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
  redirectUri: window.location.origin + '/login/callback',
  scopes: ['openid', 'profile', 'email', 'lambda:write'],
};

// Export the Okta configuration object and OktaAuth instancee
export default oktaConfig;
export const oktaAuth = new OktaAuth(oktaConfig);

